<template>
  <div>
    <Navigation/>

    <div class="container is-fluid" style="margin-top:18px;">

      <nav class="level">

        <div class="level-left">
          <div class="level-item">
            <p class="subtitle is-3">
              <strong style="color:#fff;">Settings</strong>
            </p>
          </div>
        </div>

        <div class="level-right">
        </div>

      </nav>

      <div class="card">
        <section class="section">
          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Projects</p>
                <p class="title">{{ (userInfo.projects) ? Object.keys(userInfo.projects).length : 0 }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Plan</p>
                <p class="title">{{formatPlan}}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Member Since</p>
                <p class="title">{{ memberDate }}</p>
              </div>
            </div>
          </nav>


          <div class="columns">
            <div class="column is-two-thirds">

                <label class="label">Email</label>
                <b-field>
                    <b-input
                        type="email"
                        :value="currentUser.email"
                        disabled>
                    </b-input>
                </b-field>

                <label class="label">Set New Password</label>
                 <b-field>
                    <b-input
                        v-model="currentPassword"
                        type="password"
                        placeholder="Current Password"
                        password-reveal
                        required>
                    </b-input>
                </b-field>

                <b-field>
                    <b-input
                        v-model="password"
                        type="password"
                        placeholder="Password"
                        password-reveal
                        required>
                    </b-input>
                </b-field>

                <b-field>
                    <b-input
                        v-model="verifyPassword"
                        type="password"
                        placeholder="Verfiy Password"
                        password-reveal
                        required>
                    </b-input>
                </b-field>

                 <div class="field">
                  <p class="control">
                    <button @click="setNewPassword" class="button">
                      Set New Password
                    </button>
                  </p>
                </div>


            </div>
            <div class="column">

              <b>Registered Date:</b>
              <p class="is-size-5">{{ getRegisteredDate }}</p>

              <hr>

              <b>Questions?</b><br><br>
              <button class="button is-primary" href="mailto:support@helixchart.com">
                Contact Support &nbsp;
                <span class="icon is-small">
                  <i class="fa fa-question-circle"></i>
                </span>
              </button>



            </div>
          </div>


<!--           <button class="button is-danger">
            Close Account
          </button> -->

        </section>
      </div>

    </div>

  </div>
</template>

<script>
import firebase from 'firebase';
import Navigation from './Navigation';
import utils from '@/utils';

export default {
  name: 'Settings',
  components: {
    Navigation,
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
      currentPassword: '',
      currentUser: {
        email: null,
      },
      userInfo: {
        plan: '',
      },
    };
  },
  mounted() {
    this.currentUser = firebase.auth().currentUser;
    this.getUserInfo();
  },
  computed: {
    formatPlan() {
      const plan = (this.userInfo.plan === 'beta') ? 'basic' : this.userInfo.plan;
      return utils.toTitleCase(plan);
    },
    memberDate() {
      return new Date(this.userInfo.registered).getFullYear();
    },
    getRegisteredDate() {
      return new Date(this.userInfo.registered).toDateString();
    }
  },
  methods: {
    route(location) {
      this.$router.replace(location);
    },
    isValidPassword() {
      return (this.currentPassword.length > 1 &&
              this.password === this.verifyPassword &&
              this.password.length > 5) || false;
    },
    getUserInfo() {
      firebase.database().ref('users/' + this.currentUser.uid).once('value').then((snapshot) => {
        if (snapshot.val() !== null) {
          this.userInfo = snapshot.val();
        }
      });
    },
    submitNewPassword() {
      firebase.auth().currentUser.updatePassword(this.password).then(() => {
        this.password = '';
        this.verifyPassword = '';
        this.currentPassword = '';
        this.$toast.open({
          message: 'Password updated.',
          type: 'is-success',
        });
      }).catch((error) => {
        console.log(error);
        this.$toast.open({
          message: 'Error updating password.',
          type: 'is-danger',
        });
      });
    },
    reauthenticateUser() {
      const credential = firebase.auth.EmailAuthProvider.credential(
          this.currentUser.email,
          this.currentPassword
      );
      firebase.auth().currentUser.reauthenticateWithCredential(credential)
      .then(() => {
        this.submitNewPassword();
      }).catch((error) => {
        this.$toast.open({
          message: error.message,
          type: 'is-danger',
        });
      });
    },
    setNewPassword() {
      if (this.isValidPassword()) {
        this.reauthenticateUser();
      } else {
        this.$toast.open({
          message: 'Passwords do not match or password is too short.',
          type: 'is-danger',
        });
      }
    },
    closeAccount() {
      // const uid = this.currentUser.uid;
      // this.getProjectIds();

      // this.currentUser.delete().then(function() {
      //   // remove projects and user data
      //   var updates = {};
      //   this.projectIds.forEach((projectId) => {
      //     updates['/projects/' + projectId] = null;
      //   });
      //   updates['/users/' + uid] = null;
      //   firebase.database().ref().update(updates).then(() => {
      //   });
      // }).catch(function(error) {
      //   // An error happened.
      // });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue